import { action } from "mobx";
import AwsLambdaUnzipInvocationRepository from "~/repository/AwsLambda/AwsLambdaUnzipInvocationRepository";
import NestStore from "~/stores/NestStore";

class AwsLambdaUnzipInvocationStore extends NestStore {
  /**
   * @property {AwsLambdaUnzipInvocationRepository|null}
   */
  awsLambdaUnzipInvocationRepository = null;

  constructor() {
    super();

    this.awsLambdaUnzipInvocationRepository = new AwsLambdaUnzipInvocationRepository();
  }

  @action
  create(data) {
    this.isSaving = true;

    return this.awsLambdaUnzipInvocationRepository.create(data).finally(() => {
      this.isSaving = false;
    });
  }
}

export default AwsLambdaUnzipInvocationStore;
